import { INK } from './palette.js';

/**
 * The chest.
 *
 * Three states, because the opening is the whole moment: shut and waiting,
 * shaking because it is about to go, and open.
 *
 * Drawn rather than animated with a library - the shake and the burst are CSS
 * on top of this, so `prefers-reduced-motion` can switch them off without
 * changing what the child sees, only how it arrives.
 */

const WOOD = '#a9784f';
const WOOD_DARK = '#7d5636';
const BAND = '#e8b530';
const BAND_DARK = '#b1861a';

export function Chest({ size = 160, state = 'shut' }: { size?: number; state?: 'shut' | 'open' }) {
  const open = state === 'open';
  return (
    <svg
      viewBox="0 0 120 100"
      width={size}
      height={size * (100 / 120)}
      role="img"
      aria-hidden="true"
    >
      {/* base */}
      <path
        d="M14 52 h92 v34 a6 6 0 0 1 -6 6 H20 a6 6 0 0 1 -6 -6 z"
        fill={WOOD}
        stroke={INK}
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path d="M14 66 h92" stroke={BAND} strokeWidth="7" />
      <path d="M14 66 h92" stroke={BAND_DARK} strokeWidth="2" opacity="0.5" />
      <path d="M34 52 v40 M86 52 v40" stroke={WOOD_DARK} strokeWidth="3" opacity="0.6" />

      {/* lid - hinged back when open */}
      <g
        style={{
          transform: open ? 'rotate(-38deg)' : 'rotate(0deg)',
          // Explicit: Safari does not reliably default an SVG group's
          // transform-box, and without this the lid pivots off-screen.
          transformBox: 'view-box',
          transformOrigin: '14px 52px',
          transition: 'transform .5s cubic-bezier(.2,1.4,.4,1)',
        }}
      >
        <path
          d="M14 52 a46 30 0 0 1 92 0 z"
          fill={WOOD}
          stroke={INK}
          strokeWidth="3"
          strokeLinejoin="round"
        />
        <path d="M60 22 v30" stroke={BAND} strokeWidth="7" />
        <path d="M60 22 v30" stroke={BAND_DARK} strokeWidth="2" opacity="0.5" />
      </g>

      {!open && (
        <>
          <rect
            x="52"
            y="58"
            width="16"
            height="16"
            rx="3"
            fill={BAND}
            stroke={INK}
            strokeWidth="2.5"
          />
          <circle cx="60" cy="66" r="3" fill={INK} />
        </>
      )}
    </svg>
  );
}
